import GQLClient from "../../Config/GraphqlConfig";
import RootStore from "../../Store";

import { getBookingRequest, getPrestaAppart, getCustomerAppart, CheckoutDetails, QueryGetCheckoutDetailsArgs, ProfileInfos, QueryTestCallArgs, TestCallObject, QueryGetBookingCalendarArgs, QueryGetBookingEventArgs, QueryGetBookingDetailsArgs, QueryGetMarkedEventArgs, QueryGetDetailOfEventArgs, QueryGetEventOfMonthArgs, PrestaCalendar, BookingEventPresta, PrestaDetails, EventMarkedPresta, DetailsEventPresta, EventOfMonthPresta, PrestaInvoices, Achats, BookingRequest, OA_Available_Invoice_Month } from "../type/type";
import { GET_CHECKOUT_DETAIL, GET_CUSTOMER_APPART, GET_BOOKING_REQUEST, GET_PRESTA_CONSUMMABLE, GET_PRESTA_APPART, GET_BOOKING_CALENDAR, GET_PRESTA_INVOICES, GET_MARKED_EVENTS, GET_BOOKING_DETAIL, GET_BOOKING_EVENT, TEST_CALL, GET_EVENT_DETAIL, GET_EVENT_MONTH, GET_PRESTA_INFO, GET_PRESTA_CONSUMMABLE_NEW, GET_INVOICE_DETAIL, GET_MONTHLY_DATA, GET_AVAILABLE_INVOICE_MONTHS } from "./index.definitions";


const { userInfo } = RootStore?.getInstance()

export default class Queries {
    private client = GQLClient.getIntance()?.getClient()

    /*
    for push context to server
    context: {
        headers: {
            token: tokenContext
        }
    }
    */

    getPrestaAppart() {
        return this.client
            .query<
                { getPrestaAppart: getPrestaAppart }
            >(
                {
                    query: GET_PRESTA_APPART,
                    variables: {

                    },
                    context: {
                        headers: {
                            token: userInfo.getToken()
                        }
                    },
                    fetchPolicy: 'no-cache'
                }
            );
    }

    getCustomerAppart() {
        return this.client
            .query<
                { getCustomerAppart: getCustomerAppart }
            >(
                {
                    query: GET_CUSTOMER_APPART,
                    variables: {

                    },
                    context: {
                        headers: {
                            token: userInfo.getToken()
                        }
                    },
                    fetchPolicy: 'no-cache'
                }
            );
    }

    getLastPrestaConsummable() {
        return this.client
            .query<
                { getLastPrestaConsummable: Achats[] }
            >(
                {
                    query: GET_PRESTA_CONSUMMABLE,
                    variables: {

                    },
                    context: {
                        headers: {
                            token: userInfo.getToken()
                        }
                    },
                    fetchPolicy: 'no-cache'
                }
            );
    }

    getLastPrestaConsummableNew() {
        return this.client
            .query<
                { getLastPrestaConsummable: Achats[] }
            >(
                {
                    query: GET_PRESTA_CONSUMMABLE_NEW,
                    variables: {

                    },
                    context: {
                        headers: {
                            token: userInfo.getToken()
                        }
                    },
                    fetchPolicy: 'no-cache'
                }
            );
    }

    TestCall(test: string) {
        return this.client
            .query<
                { testCall: TestCallObject },
                QueryTestCallArgs
            >(
                {
                    query: TEST_CALL,
                    variables: {
                        test
                    },
                    context: {
                        headers: {
                            token: userInfo.getToken()
                        }
                    }
                }
            );
    }

    getBookingCalendar(Month: string) {
        return this.client
            .query<{ getBookingCalendar: PrestaCalendar },
                QueryGetBookingCalendarArgs
            >(
                {
                    query: GET_BOOKING_CALENDAR,
                    variables: {
                        Month
                    },
                    context: {
                        headers: {
                            token: userInfo.getToken()
                        }
                    },
                    fetchPolicy: 'no-cache'
                }
            )
    }

    getBookingEvent(day: string) {
        return this.client
            .query<{ getBookingEvent: BookingEventPresta },
                QueryGetBookingEventArgs
            >(
                {
                    query: GET_BOOKING_EVENT,
                    variables: {
                        day
                    },
                    context: {
                        headers: {
                            token: userInfo.getToken()
                        }
                    },
                    fetchPolicy: 'no-cache'
                }
            )
    }

    getBookingDetails(bookingId: string, lang: string) {
        return this.client
            .query<{ getBookingDetails: PrestaDetails },
                QueryGetBookingDetailsArgs
            >(
                {
                    query: GET_BOOKING_DETAIL,
                    variables: {
                        bookingId,
                        lang
                    },
                    context: {
                        headers: {
                            token: userInfo.getToken()
                        }
                    },
                    fetchPolicy: 'no-cache'
                }
            )
    }

    getCheckoutDetails(eventId: string) {
        return this.client
            .query<{ getCheckoutDetails: CheckoutDetails },
                QueryGetCheckoutDetailsArgs
            >(
                {
                    query: GET_CHECKOUT_DETAIL,
                    variables: {
                        eventId,
                    },
                    context: {
                        headers: {
                            token: userInfo.getToken()
                        }
                    },
                    fetchPolicy: 'no-cache'
                }
            )
    }

    getMarkedEvents(date: string) {
        return this.client
            .query<{ getMarkedEvent: EventMarkedPresta },
                QueryGetMarkedEventArgs
            >(
                {
                    query: GET_MARKED_EVENTS,
                    variables: {
                        date
                    },
                    context: {
                        headers: {
                            token: userInfo.getToken()
                        }
                    },
                    fetchPolicy: 'no-cache'
                }
            )
    }

    getEventDetail(eventId: string, lang: string) {
        return this.client
            .query<{ getDetailOfEvent: DetailsEventPresta },
                QueryGetDetailOfEventArgs
            >(
                {
                    query: GET_EVENT_DETAIL,
                    variables: {
                        eventId,
                        lang
                    },
                    context: {
                        headers: {
                            token: userInfo.getToken()
                        }
                    },
                    fetchPolicy: 'no-cache'
                }
            )
    }

    getEventOfMonth(date: string) {
        return this.client
            .query<{ getEventOfMonth: EventOfMonthPresta },
                QueryGetEventOfMonthArgs
            >(
                {
                    query: GET_EVENT_MONTH,
                    variables: {
                        date
                    },
                    context: {
                        headers: {
                            token: userInfo.getToken()
                        }
                    },
                    fetchPolicy: 'no-cache'
                }
            )
    }

    getPrestaInfo() {
        return this.client
            .query<{ getPrestaInfo: ProfileInfos }
            >(
                {
                    query: GET_PRESTA_INFO,
                    context: {
                        headers: {
                            token: userInfo.getToken()
                        }
                    },
                    fetchPolicy: 'no-cache'
                }
            )
    }

    getPrestaInvoices() {
        return this.client
            .query<{ getCompanyInvoices: PrestaInvoices }
            >(
                {
                    query: GET_PRESTA_INVOICES,
                    context: {
                        headers: {
                            token: userInfo.getToken()
                        }
                    },
                    fetchPolicy: 'no-cache'
                }
            )
    }

    getUserBookingRequest() {
        return this.client
            .query<{ getBookingRequest: getBookingRequest }>
            (
                {
                    query: GET_BOOKING_REQUEST,
                    context: {
                        headers: {
                            token: userInfo.getToken()
                        }
                    },
                    fetchPolicy: 'no-cache'
                }
            )
    }

    getInvoiceDetail(date) {
        return this.client.query({
            query: GET_INVOICE_DETAIL,
            variables: { date },
            context: {
                headers: {
                    token: userInfo.getToken()
                }
            },
            fetchPolicy: 'no-cache'
        });
    }


    getMonthlyData(date) {
        return this.client.query({
            query: GET_MONTHLY_DATA,
            variables: { date },
            context: {
                headers: {
                    token: userInfo.getToken()
                }
            },
            fetchPolicy: 'no-cache'
        });
    }


    getAvailableInvoiceMonths() {
        return this.client
            .query<{ OA_getAvailableInvoiceMonths: OA_Available_Invoice_Month[] }>({
                query: GET_AVAILABLE_INVOICE_MONTHS,
                context: {
                    headers: {
                        token: userInfo.getToken()
                    }
                }
            })
    }

}